/* eslint-disable import/extensions */
/* eslint-disable react/no-unused-prop-types */
import CircleChart from 'components/CircleChart'
import { ccb, whiteFlag } from 'assets/Icons'
import { formatInvestCard, calcularContraste } from 'helper/utils'
import { IInvestCard } from 'interfaces'
import { useContext } from 'react'
import { UserContext } from 'context/userContext'
import { IMAGES } from 'configs/configs.js'
import { Icon } from 'assets/index'
import trashWhite from '../KanbanCard/trashWhite.svg'
import * as Style from './style'

interface IInvestCardProps {
  item: IInvestCard
  i?: number
  disabled?: boolean
  onClick?: (..._param: any) => void
  isPreview?: boolean
  shadow?: boolean
  isEnterprise?: boolean
}

const ImageContent = (props: any) => {
  const { item, isPreview, isEnterprise } = props
  const { preview } = useContext(UserContext)
  const image = isPreview
    ? preview
    : `${IMAGES.URL}/images/${item?.style?.image?.name}`
  const [color] = item?.style?.color || ['#565656']

  return (
    <Style.ImageContainer img={image}>
      <Style.Gradient opacity={item?.style?.image?.opacity}>
        <Style.ImageContent>
          <Style.Tags start>
            {item.tags.map((tag: string) => (
              <Style.ColoredTag color={color} key={`color-tag-poster-${tag}`}>
                <Style.TagText color={calcularContraste(color)}>
                  {tag}
                </Style.TagText>
              </Style.ColoredTag>
            ))}
          </Style.Tags>

          <Style.MinRow start>
            <img className="svg-card-icon" src={ccb} alt="card icon" />
            <Style.InvestTitle>{`${item?.name}${
              isEnterprise ? '' : `/${new Date(item?.releaseAt).getFullYear()}`
            }`}</Style.InvestTitle>
          </Style.MinRow>
        </Style.ImageContent>
      </Style.Gradient>
    </Style.ImageContainer>
  )
}

const CardContent = ({ item }: IInvestCardProps) => {
  const [color] = item?.style?.color || ['#565656']
  return (
    <Style.CardContainer isEvenly={!item?.url}>
      <>
        {item?.chart && (
          <CircleChart
            radius={55}
            valueArray={item?.chart?.sectionList}
            strokeWidth={3}
          >
            <Style.RateColoured color={'#DF7A58'}>
              {item.chart.title}
            </Style.RateColoured>
            <Style.RateText>{item.chart.subtitle}</Style.RateText>
          </CircleChart>
        )}
        {item?.label && (
          <Style.MinRow center>
            <Style.InvestText>{`${item?.label}:`}</Style.InvestText>
            <Style.MoneyText>{`${
              item?.value === undefined ? 0 : item?.value
            }`}</Style.MoneyText>
          </Style.MinRow>
        )}
      </>
      {/* {item?.url && ( */}
      {/* <Style.Link color={color} href={item?.url}>
        Link web
        <img className="link-elo-icon" src={Icon('link.svg')} alt="link icon" />
        </Style.Link> */}
      {/* )} */}
    </Style.CardContainer>
  )
}

const InvestCard = ({
  item,
  i,
  onClick,
  disabled = false,
  isPreview = false,
  shadow,
  isEnterprise = false,
}: IInvestCardProps) => {
  const data = formatInvestCard(item)
  const [color] = item?.style?.color || ['#565656']

  return (
    <Style.Container
      color={color}
      key={`label_poster_card_${i}`}
      shadow={shadow}
      data-testid={`card-${data?.name}`}
    >
      {/* {item?.guarantee && (
        <>
          <Style.FlagIcon src={whiteFlag} />
          <Style.FlagText color={item?.style?.color[0]}>
            {item?.guarantee}
          </Style.FlagText>
        </>
      )} */}
      <Style.Card shadow={shadow} onClick={onClick}>
        <>
          <ImageContent
            isPreview={isPreview}
            item={data}
            isEnterprise={isEnterprise}
          />
          <CardContent item={data} disabled={disabled} i={0} />
        </>
      </Style.Card>
    </Style.Container>
  )
}

export default InvestCard
